import { cn } from "@/utils/cn";

/**
 * Compact vertical-list info item for document/file viewer pages.
 *
 * Visual style: square 44×44 icon container + uppercase label + value.
 * Distinct from RequestInfoGrid (which uses a responsive grid + centered items).
 *
 * Use this for: document-detail, ViewDocument, file-details pages.
 * Use RequestInfoGrid for: request detail pages (leave, overtime, assets, etc.).
 */
interface DocumentReviewDetailItemProps {
  icon: React.ReactNode;
  /** Tailwind bg color segment, e.g. "primary/10" or "success/10". */
  color?: string;
  label: string;
  value: React.ReactNode;
  valueClassName?: string;
}

const DocumentReviewDetailItem = ({
  icon,
  color = "primary/10",
  label,
  value,
  valueClassName,
}: DocumentReviewDetailItemProps) => (
  <div className="flex gap-2 items-start">
    <div
      className={`shrink-0 w-11 h-11 rounded-sm flex items-center justify-center bg-${color}`}
    >
      {icon}
    </div>
    <div className="flex flex-col gap-1 justify-between h-full">
      <div className="text-xs font-medium uppercase text-muted-foreground">
        {label}
      </div>
      <div className={cn(valueClassName, "text-sm mt-auto")}>{value}</div>
    </div>
  </div>
);

export default DocumentReviewDetailItem;
